"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMaskPreset = void 0;
var InputMaskPreset;
(function (InputMaskPreset) {
    InputMaskPreset["HEX"] = "///HEX";
    InputMaskPreset["TIME"] = "///TIME";
})(InputMaskPreset || (exports.InputMaskPreset = InputMaskPreset = {}));
const MASK_PRESETS = {
    [InputMaskPreset.HEX]: {
        mask: 'PXXXXXX',
        definitions: {
            P: /#/,
            X: /([A-Fa-f\d])/,
        },
    },
    [InputMaskPreset.TIME]: {
        mask: 'Hh:Mm',
        definitions: {
            H: /[0-2]/,
            h: (value) => (value[0] === '2' ? /[0-3]/ : /[0-9]/),
            M: /[0-5]/,
            m: /[0-9]/,
        },
    },
};
exports.default = MASK_PRESETS;
